define('datakit/lib/relationship.type',['require','exports','module','underscore','backbone','marionette','backbone.radio','bluebird'],function(require, exports, module) {
  var _        = require('underscore');
  var Backbone = require('backbone');
  var Mn       = require('marionette');
  var Radio    = require('backbone.radio');
  var Promise  = require('bluebird');


  var RelationshipType = Mn.Object.extend({

    staleOnForeignModelEvent: null,
    clearOnForeignModelEvent: null,
    supportedResourceClass: null,
    supportedForeignKey: null,
    supportedForeignKeys: null,

    initialize: function() {
      this.mergeOptions(this.options, [
        'resource',
        'foreignKey',
        'foreignModel',
        'relationship'
      ]);
      
      this.relationshipName = this.getOption('name');
      this.didSyncLastRequest = false;

      this.listenTo(this.resource, 'request', function(resource, xhr, options) {
        this.lastRequestXhr = xhr;
      });

      this.listenTo(this.resource, 'sync', function(resource, response, options) {
        // this is used to determine if the fetch
        // synced the model or only fetched the data
        this.didSyncLastRequest = true;
      });

      this.on('request', function() {
        this.didSyncLastRequest = false;
      });

      this.on('fetch:success', function(response, options) {
        if (!this.didSyncLastRequest) {
          this.resource.trigger('sync', this.resource, response || {}, options || {});
        }
      });

      var staleEvent = _.result(this, 'staleOnForeignModelEvent');
      if (staleEvent) {
        this.listenTo(this.foreignModel, staleEvent, function() {
          this.relationship.setStale();
        });
      }

      var clearEvent = _.result(this, 'clearOnForeignModelEvent');
      if (clearEvent) {
        this.listenTo(this.foreignModel, clearEvent, function() {
          this.relationship.clearResource();
        });
      }

      // always validate on initialize
      this.validate();
    },

    validate: function() {
      if (!this.hasValidForeignKeyAttribute()) {
        var relationshipTypeName = this.getOption('type');
        if (_.isString(relationshipTypeName) && _.isString(this.foreignKey)) {
          throw new Error('The relationship type "' 
            + relationshipTypeName + '" does not support the'
            + ' foreignKey "' + this.foreignKey + '".');
        }
        else if (_.isString(this.foreignKey)) {
          throw new Error('A relationship was given an invalid'
            + ' foreignKey of "' + this.foreignKey + '".');
        }
        else {
          throw new Error('A relationship type was given an invalid foreignKey.');
        }
      }
      if (!this.hasValidResource()) {
        throw new Error('A relationship type was given an invalid resource class.');
      }
    },

    hasValidResource: function() {
      var supportedResourceClass = this.getOption('supportedResourceClass');
      if (supportedResourceClass) {
        return (this.resource instanceof supportedResourceClass);
      }
      return true;
    },

    hasValidForeignKeyAttribute: function() {
      var supportedForeignKey = Mn._getValue(this.getOption('supportedForeignKey'), this);
      var supportedForeignKeys = Mn._getValue(this.getOption('supportedForeignKeys'), this);
      if (supportedForeignKey) {
        return this.foreignKey == supportedForeignKey;
      }
      else if (_.isArray(supportedForeignKeys)) {
        return _.contains(supportedForeignKeys, this.foreignKey);
      }
      return true;
    },

    canFetchResource: function() {
      return true;
    },

    configureResource: function() {
      
    },

    // returns promise or xhr
    fetchResource: function(options) {
      return this.resource.fetch(options);
    },

    onFetchSuccess: function(response, options) {
      if (!this.didSyncLastRequest) {
        this.resource.set(this.parseResponse(response));
      }
    },

    parseResponse: function(response) {
      return response;
    }

  });

  module.exports = RelationshipType;
});
